export const VERSION = '1.5.1'

export const VERSION_STORAGE_KEY = 'truckbook-version'

export const EnvironmentNames = Object.freeze({
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
  SANDBOX: 'sandbox',
  LOCAL: 'local',
})

export const USE_DEV_CONSOLE =
  import.meta.env.VITE_ENV === EnvironmentNames.PRODUCTION
    ? false
    : localStorage.getItem('USE_DEV_CONSOLE') === 'true'
